import { useMainStore } from '@/modules/shared/stores/main.store'
import { Promotion } from '../types/promotion.type'
import { api } from '@/modules/shared/lib/axios'
import type { PayloadSearch } from '@/modules/shared/types/payload-search.type'

interface ApiResponse {
  status: number
  message: string
  body: string
}

export type TTransmitPromotionVisitsService = {
  payload: {
    visitIds: string[]
  }
}

export const usePromotionSearchData = () => {
  const fetchPromotions = async (payload: PayloadSearch['payload']) => {
    try {
      let tipo = 'contendo'
      const campo = payload.filter
      const expressao = payload.inputValue

      if (campo === 'id_visita' || campo === 'data') {
        tipo = 'igual'
      }
			console.log(payload)

      const url = `/promotorvisita/online/${tipo}/${campo}/${expressao}`
      const response = await api.get<ApiResponse>(url)

      const promotions: Promotion[] = JSON.parse(response.data.body)

      return promotions
    } catch (error) {
      console.error('Erro ao buscar visitas:', error)
      throw error
    }
  }

  const deletePromotion = async ({ payload }: { payload: { visitId: string } }) => {
    try {
      await api.delete(`/promotorvisita/online/id/${payload.visitId}`)
      return true
    } catch (error) {
      console.error('Erro ao excluir visita:', error)
      throw error
    }
  }

  const transmitPromotionVisitsService = async ({ payload }: TTransmitPromotionVisitsService) => {
    try {
      // Join the IDs with commas as specified in the API endpoint
      const idsParam = payload.visitIds.join(',')

      const response = await api.post(`/promotorvisita/online/transmitir/${idsParam}`)
      return response.data
    } catch (error) {
      console.error('Erro ao transmitir visitas:', error)
      throw error
    }
  }

  return {
    fetchPromotions,
    deletePromotion,
    transmitPromotionVisitsService,
  }
}